exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-wrapper {\r\n    width: 90%;\r\n    max-width: 51.2rem;\r\n}\r\n\r\n.content {\r\n    position: relative;\r\n    top: 105px;\r\n    text-align: center;\r\n}\r\n\r\n.error-code {\r\n    font-weight: 500;\r\n    color: rgba(0,0,0,.87);\r\n}\r\n\r\n.search-column {\r\n    height: 56px;\r\n    margin: 30px 0 10px 0;\r\n    border: 2px solid #dcdcdc;\r\n    border-radius: 5px;\r\n    -webkit-box-shadow: 0 2px 1px -1px rgba(0, 0, 0, .2), 0 1px 1px 0 rgba(0, 0, 0, .14), 0 1px 3px 0 rgba(0, 0, 0, .12);\r\n            box-shadow: 0 2px 1px -1px rgba(0, 0, 0, .2), 0 1px 1px 0 rgba(0, 0, 0, .14), 0 1px 3px 0 rgba(0, 0, 0, .12)\r\n}\r\n\r\n.back-link{\r\n    font-size: 1.1rem !important;\r\n}\r\n\r\n.search i {\r\n    font-size: 20px;\r\n    margin: 0 15px;\r\n}\r\n\r\n.back-link {\r\n    font-size: 1.5rem;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/errors/page-not-found/page-not-found.component.css
// module id = ../../../../../src/app/pages/errors/page-not-found/page-not-found.component.css
// module chunks = main